import { PopoverProps } from '@material-ui/core/Popover';

const MuiPopover: Partial<PopoverProps> = {
    elevation: 2,
};

export default MuiPopover;
